<script lang="ts" setup>
import { useItemStore } from "@/itemStore";
import { useI18n } from "vue-i18n";
import DropdownElement from "@/components/DropdownElement.vue";

const props = defineProps<{
  taxonomy: string;
  placeholder?: string;
  root?: string;
}>();

const itemStore = useItemStore();

const { t } = useI18n();

const setValue = (slug: string) => {
  itemStore.setFilter(props.taxonomy, slug, true);
};

const getValue = () => itemStore.filter[props.taxonomy]?.join(",") ?? "";
</script>

<template>
  <DropdownElement
    :options="itemStore.getOptions(props.taxonomy, true, props.root)"
    :value="getValue()"
    :empty="t('all')"
    :placeholder="placeholder ?? ''"
    @select="setValue"
  />
</template>
